import React, { useEffect } from "react";
import { Route, useLocation } from "react-router-dom";
import PropTypes from "prop-types";

import { useAuth } from "../auth/AuthProvider";
import LoadingComponent from "./LoadingComponent";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const location = useLocation();
  const { isInitialized, isAuthenticated, loginRedirect } = useAuth();

  useEffect(() => {
    if (isInitialized && !isAuthenticated) {
      loginRedirect({
        redirectPath: `${location.pathname}${location.search}${location.hash}`,
      });
    }
  }, [isAuthenticated, isInitialized, location, loginRedirect]);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isInitialized || !isAuthenticated) {
          return <LoadingComponent loading />;
        }

        return <Component {...props} />;
      }}
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType,
};

export default ProtectedRoute;
